<template>
  <!-- TODO: 修改为类似 在线访客 页面 table形式 -->
  <div class="app">
    <!--<splitpanes class="default-theme">
      <pane size="20">
        <bd-aside></bd-aside>
      </pane>
      <pane size="80">
        <bd-main></bd-main>
      </pane>
    </splitpanes>-->
    <bd-table-web></bd-table-web>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
// import { Splitpanes, Pane } from 'splitpanes'
// import 'splitpanes/dist/splitpanes.css'
// import BdAside from '@/components/dashboard/main/queue/BdAside'
// import BdMain from '@/components/dashboard/main/queue/BdMain'
import BdTableWeb from '@/components/dashboard/main/queue/BdTableWeb'

export default {
  name: 'bd-online',
  // components: { BdAside, BdMain, Splitpanes, Pane },
  components: { BdTableWeb },
  data () {
    return {
    }
  }
}
</script>

<style scope>
</style>
